import PropTypes from 'prop-types'

const propTypes = {
    value: PropTypes.bool,
}

const defaultProps = {
    value: false,
}

const BooleanValue = (props) => {
    const {
        value,
    } = props

    return (
        <div>
            {value ? 'Yes' : 'No'}
        </div>
    )
}

BooleanValue.propTypes = propTypes
BooleanValue.defaultProps = defaultProps

export default BooleanValue
